import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Rocket } from "lucide-react";
import api from "../lib/api";
import { timeParts } from "../lib/format";
import { findLaunchComps, earliestLaunchAt } from "../lib/launch";

// Fallback if no launch competition is configured in the backend yet.
export const LAUNCH_DATE = "2026-08-01T21:00:00Z";

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="min-w-[64px] sm:min-w-[84px] rounded-xl bg-black border border-[rgba(255,184,0,.35)] px-2 py-3 sm:px-4 sm:py-4">
      <span className="font-display text-4xl sm:text-6xl glow-gold tabular-nums">{String(value).padStart(2, "0")}</span>
    </div>
    <span className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-[var(--text-muted)]">{label}</span>
  </div>
);

export const LaunchCountdown = ({ target }) => {
  const [tgt, setTgt] = useState(target || LAUNCH_DATE);
  const [draws, setDraws] = useState([]);
  const [t, setT] = useState(timeParts(target || LAUNCH_DATE));

  // Sync to the earliest launch draw's go-live date from the shared backend.
  useEffect(() => {
    if (target) { setTgt(target); return; }
    api.get("/competitions").then(({ data }) => {
      const list = findLaunchComps(data);
      setDraws(list);
      const at = earliestLaunchAt(data);
      if (at) setTgt(at);
    }).catch(() => {});
  }, [target]);

  useEffect(() => {
    setT(timeParts(tgt));
    const id = setInterval(() => setT(timeParts(tgt)), 1000);
    return () => clearInterval(id);
  }, [tgt]);

  const firstDraw = draws[0] || null;
  const multiple = draws.length > 1;

  return (
    <div className="countdown-gold" data-testid="site-launch-countdown">
      <div className="neon-inner p-6 sm:p-10 text-center">
        <div className="flex items-center justify-center gap-2 text-[var(--neon-gold)]">
          <Rocket className="h-5 w-5" />
          <span className="font-display uppercase tracking-[0.3em] text-sm sm:text-base">Site Launch Countdown</span>
        </div>
        <p className="mt-1 text-xs text-[var(--text-muted)] uppercase tracking-widest">
          {draws.length ? `${draws.length} launch special${multiple ? "s" : ""} to enter now` : "The big launch is coming"}
        </p>
        {t.done ? (
          <p className="mt-6 font-display text-4xl sm:text-6xl glow-gold">WE ARE LIVE!</p>
        ) : (
          <div className="mt-6 flex items-end justify-center gap-3 sm:gap-5">
            <Unit value={t.d} label="Days" />
            <Unit value={t.h} label="Hours" />
            <Unit value={t.m} label="Mins" />
            <Unit value={t.s} label="Secs" />
          </div>
        )}
        {firstDraw && !t.done && (
          <Link to={multiple ? "/competitions" : `/competitions/${firstDraw.id}`} data-testid="launch-comp-cta" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[var(--neon-gold)] text-black font-display uppercase tracking-widest px-5 py-2.5 hover:brightness-110">
            {multiple ? "Enter the Launch Draws" : "Enter the Launch Draw"}
          </Link>
        )}
      </div>
    </div>
  );
};
